import { defineMessages } from 'react-intl'

export default defineMessages({
  todaysQueue: {
    id: 'dashboard.todayQueue.title',
    defaultMessage: "Today's Queue"
  },
  waiting: {
    id: 'dashboard.todayQueue.waiting',
    defaultMessage: 'Waiting'
  },
  done: {
    id: 'dashboard.todayQueue.done',
    defaultMessage: 'Done'
  },
  markDone: {
    id: 'dashboard.todayQueue.markDone',
    defaultMessage: 'Mark Done'
  },
  noPatientsInQueueToday: {
    id: 'dashboard.todayQueue.noPatientsInQueueToday',
    defaultMessage: 'No patients in queue today'
  },
  addASecretary: {
    id: 'dashboard.todayQueue.addASecretary',
    defaultMessage: 'Add a secretary to manage your queue'
  },
  settings: {
    id: 'dashboard.todayQueue.settings',
    defaultMessage: 'Settings'
  },
  failedToMarkDone: {
    id: 'dashboard.todayQueue.failedToMarkDone',
    defaultMessage: 'Failed to mark patient as done'
  }
})
